<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 21H20M5.666 13.187C5.23943 13.6142 4.99989 14.1933 5 14.797V18H8.223C8.827 18 9.406 17.76 9.833 17.332L19.333 7.82697C19.7597 7.39983 19.9994 6.82075 19.9994 6.21697C19.9994 5.61319 19.7597 5.03411 19.333 4.60697L18.395 3.66697C18.1835 3.45532 17.9323 3.28744 17.6558 3.17294C17.3794 3.05843 17.083 2.99954 16.7838 2.99963C16.4846 2.99973 16.1883 3.0588 15.9119 3.17348C15.6355 3.28816 15.3844 3.45619 15.173 3.66797L5.666 13.187Z"
      class="stroke-current"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
